import { render } from "./MenuIconClose.vue?vue&type=template&id=b146ac20"
import script from "./MenuIconClose.vue?vue&type=script&lang=js"
export * from "./MenuIconClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__